<template>
  <div>
    <div class="left">
      <geofence-map/>
    </div>
    <div class="right">
      <geo-fence-list v-show="!isAddGeofence && !isEditGeofence"/>
      <geo-fence-add v-show="isAddGeofence || isEditGeofence"/>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import GeofenceMap from '@/pages/map/components/geofencemap';
import GeoFenceList from '@/pages/geofence/components/List';
import GeoFenceAdd from '@/pages/geofence/components/Add';
import { mapGetters } from 'vuex';

export default {
  components: {
    GeofenceMap,
    GeoFenceList,
    GeoFenceAdd
  },
  computed: {
    ...mapGetters(['isAddGeofence', 'isEditGeofence'])
  }
};
</script>
<style scoped>
.left {
  width: calc(100% - 400px);
  height: calc(100vh - 64px);
}
.right {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/geofence/index.vue